import React, { useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { apiUrl } from '../config/api';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus(null);
    try {
      await axios.post(apiUrl('/api/auth/forgot-password'), { email });
      setStatus({ ok: true, msg: 'If an account exists, a reset link has been sent.' });
    } catch (e) {
      setStatus({ ok: false, msg: e?.response?.data?.error || 'Request failed' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-slate-950 flex items-center justify-center px-4">
      <div className="w-full max-w-sm bg-white dark:bg-slate-800 rounded-lg shadow p-6">
        <h2 className="text-center text-xl font-semibold text-gray-800 dark:text-slate-100 mb-4">Forgot your password?</h2>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-800 dark:text-slate-200 mb-1">Email</label>
            <input type="email" value={email} onChange={e=>setEmail(e.target.value)} required className={`w-full ${email ? '' : 'border-rose-300 dark:border-rose-700/60 focus:border-rose-500 focus:ring-rose-500/20'}`} placeholder="you@example.com" />
          </div>
          <button type="submit" disabled={loading} className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700 disabled:opacity-60">{loading ? 'Sending…' : 'Send reset link'}</button>
          <div className="text-center text-sm">
            <Link to="/login" className="text-blue-600 dark:text-blue-400 hover:underline">Back to login</Link>
          </div>
        </form>
        {status && (
          <div className={`mt-4 text-sm text-center ${status.ok ? 'text-green-600 dark:text-green-400' : 'text-red-600 dark:text-red-400'}`}>{status.msg}</div>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
